import { Component, OnInit } from '@angular/core';
import { WebpagesService } from '../../@core/services/webpages.service';
import { AuthenticationService } from '../../@core/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { NatLanguage } from '../../@core/models/nat-language';

@Component({
  selector: 'website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.scss']
})
export class WebsiteFooterComponent implements OnInit {

  constructor(
    public _webpagesService: WebpagesService,
    public authenticationService: AuthenticationService,
    private translateService: TranslateService) {
      this._webpagesService.initialiseWebPages(0, this.authenticationService.currentUserValue.language);
    }

  ngOnInit() {
  }

}
